/**
 * @generated SignedSource<<2958711f2bc5795196c7b3730141d143>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WorkspaceRunnerPhase = "BINDING_VOLUME" | "PENDING" | "PREPARING_WORKSPACE" | "READY" | "SCHEDULING_POD" | "STARTING_POD";
export type WorkspaceViewEditorWarmupQuery$variables = {
  id: string;
};
export type WorkspaceViewEditorWarmupQuery$data = {
  readonly node: {
    readonly editor?: {
      readonly id: string;
      readonly phase: WorkspaceRunnerPhase;
    } | null | undefined;
  };
};
export type WorkspaceViewEditorWarmupQuery = {
  response: WorkspaceViewEditorWarmupQuery$data;
  variables: WorkspaceViewEditorWarmupQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "WorkspaceRunner",
      "kind": "LinkedField",
      "name": "editor",
      "plural": false,
      "selections": [
        (v2/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "phase",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WorkspaceVersion",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceViewEditorWarmupQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "WorkspaceViewEditorWarmupQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v3/*:: as any*/),
          (v2/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8264fd51ec130dbdc12637b56cc1a879",
    "id": null,
    "metadata": {},
    "name": "WorkspaceViewEditorWarmupQuery",
    "operationKind": "query",
    "text": "query WorkspaceViewEditorWarmupQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ... on WorkspaceVersion {\n      editor @ifAllowed {\n        id\n        phase\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "98b81e2a56ed523dd29532e60126a4f8";

export default node;
